// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1tkoT","alert":"SettungsInbox_alert__3U48u"};